import React, { useState, useEffect, useCallback } from 'react';
import { Button, Space, Breadcrumb, Table } from 'antd';
import { CardLayout, SortableTable, RefCodeEditModal } from 'components/molecules';
import { useRefCode } from 'hooks';
import { ColumnsType } from 'antd/lib/table/interface';
import { TotalNumMenu } from 'components/atoms';
import { usePopupManager } from 'react-popup-manager';
import { TableWrapper } from 'components/molecules';

export interface  SeminarCommonProps {}

const  SeminarCommon = ({}:  SeminarCommonProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const [tableDatas, setTableDatas] = useState<any[]>();
  const [title] = useState<string>('세미나신청그룹');
  const [fieldName] = useState<string>('seminar_group');
  const { open } = usePopupManager();


  const columns: ColumnsType<RefCodeListDto> = [
    {
      title: '그룹아이디',
      key: 'name',
      dataIndex: 'name',
      width: '150px',
      align: 'center',
    },  
    {
      title: '세미나 신청 그룹명',
      dataIndex: 'value',
      key: 'value',
      width: '200px',
      align: 'left',
    },
    {
      title: '신청 URL',
      key: 'status_type',
      width: 'auto',
      align: 'center',
      onCell: (record) => {
        return {
            onClick: (e) => {
              e.stopPropagation();
            },
        };
      },
      render: (record) => {
        return (
          <label>https://www.hsg.or.kr/seminar/세미나번호/{record.name.toLowerCase()}</label>
        )
      }
    }, 
  ];
    
  /* ======================================================
   * hooks
   * ====================================================== */
  const { refCodeList, refCodeInsert, refCodeUpdate, refCodeSort } = useRefCode({field:fieldName});  

  /* ======================================================
   * events
   * ====================================================== */    

  const onClickRegister = () => {
    open(RefCodeEditModal, {
      title: title,
      ref_code_srl: 0,
      onClose: (isOk, value) => {
        if (isOk) {
          refCodeInsert({
            field: fieldName,
            name_alias: 'SEMINAR',
            value: value,
          })    
        }
      },
    }); 
  }

  const onRowClick = useCallback((record, index) => {
    return {
      onClick: () => {
        open(RefCodeEditModal, {
          title: title,      
          ref_code_srl: record.ref_code_srl,
          value: record.value,
          onClose: (isOk, value) => {
            if (isOk) {
              refCodeUpdate({ref_code_srl: record.ref_code_srl, value: value})     
            }
          },
        });        
      },
    };
   }, []);

  /* ======================================================
   * effects
   * ====================================================== */
  useEffect(() => {
    setTableDatas(refCodeList?.map((item) => ({
      ...item,
      key: item.ref_code_srl,
    })));
  }, [refCodeList]);
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <CardLayout title={(
      <Breadcrumb>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>B2C</Breadcrumb.Item>
        <Breadcrumb.Item>세미나신청그룹관리</Breadcrumb.Item>
    </Breadcrumb>      
    )}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <TotalNumMenu text={' '} useRegister onUseRegister={onClickRegister} />
          <TableWrapper isSearch={false}>
            <Table
              dataSource={tableDatas}
              columns={columns}
              pagination={false}
              style={{ width: '100%', overflowX: 'auto', minWidth: 600 }}
              className="columnCenterFixTable"
              onRow={onRowClick}
            />          
          </TableWrapper> 
      
        </Space>            
    </CardLayout>
  )
};

export default  SeminarCommon;    